export const translations = {
  en: {
    aboutVision: "Our Vision",
    aboutVisionDesc: "We believe in a free and open internet where users have control over the content they create. TikGrab is built on the principles of speed, privacy, and quality.",
    contactIntro: "If you have any questions, bug reports, or feature suggestions for TikGrab, or if you just feel the need to say something, feel free to contact us via the contact form.",
    contactName: "Your Name",
    contactEmail: "Your Email",
    contactMessage: "Your Message",
    contactSubmit: "Send Message",
    downloader: "Downloader",
    blog: "Blog",
    tools: "Tools",
    legal: "Legal",
    resources: "Resources",
    blogAndGuides: "Blog & Guides",
    aboutUs: "About Us",
    contactUs: "Contact Us",
    heroTitle: "Download TikTok Video",
    placeholder: "Just insert a link",
    paste: "Paste",
    download: "Download",
    noWatermark: "Download Video (No Watermark)",
    standard: "Download Video (Standard)",
    withWatermark: "Download Video (With Watermark - Backup)",
    audioMp3: "Download Audio (MP3)",
    popularVideos: "Popular Videos",
    howToSave: "How to save TikTok video?",
    featureUnlimited: "Unlimited downloads",
    featureUnlimitedDesc: "Save as many videos as you need, no limits or any other restrictions.",
    featureNoWatermark: "No TikTok Watermark!",
    featureNoWatermarkDesc: "Download TikTok videos without watermark, it removes the TikTok logo.",
    featureMp4Mp3: "MP4 and MP3 supported",
    featureMp4Mp3Desc: "Save videos in hd quality, MP4 file format or convert to audio MP3.",
    bottomHeading: "Download TikTok video without watermark",
    codecNote: "Note: HD videos (HEVC) may play as audio-only in some players. If this happens, please use the 'Standard' or 'With Watermark' option.",
    loading: "Loading popular videos...",
    backToHome: "Back to Downloader",
    hdHevc: "Download Video (No Watermark)",
    standardCompatible: "Download Video (Standard)",
    downloading: "Downloading...",
    wait: "Please wait...",
    seoTextTitle: "How to Download TikTok Videos Without Watermark?",
    seoTextDesc: "TikGrab is the fastest and easiest way to save TikTok videos. Our tool removes the watermark and allows you to download in HD quality.",
    step1Title: "1. Copy Link",
    step1Desc: "Find your video on TikTok and copy its URL.",
    step2Title: "2. Paste Here",
    step2Desc: "Paste the URL into TikGrab.app's input box.",
    step3Title: "3. Download",
    step3Desc: "Choose your format and save the video instantly.",
    faqTitle: "Frequently asked questions",
    faq1Q: "How to download a TikTok video on android or iphone?",
    faq1A: "1. Open your desired video on the TikTok application. 2. Tap on the Share button at the bottom right, and then tap on the Copy Link option. 3. Return to TikGrab website and paste the copied URL into the address field on the top of this page, and then click on the Download button. 4. Wait while TikGrab processes the video. Choose the desired quality and download the video.",
    faq2Q: "Where are TikTok videos saved after download?",
    faq2A: "When you are downloading files, they are usually saved into whichever folder you have set as your default. Your browser normally sets this folder for you. In browser settings you can change and choose manually the destination folder for your downloaded TikTok videos.",
    faq3Q: "How to download TikTok videos on my PC?",
    faq3A: "1. Open TikTok.com in your browser. 2. Copy the video URL from the browser address bar or by clicking 'Share'. 3. Paste the link into TikGrab.app and hit download.",
    faq4Q: "Is using TikGrab free?",
    faq4A: "Yes, our service is completely free and unlimited. We don't ask for any money or subscriptions.",
    faq5Q: "Does TikGrab keep a copy of downloaded videos?",
    faq5A: "No, TikGrab does not store videos. All videos are hosted on TikTok's servers. Also, we don't keep track of the download histories of our users, making using TikGrab totally anonymous.",
    faq6Q: "How can I get the TikTok video link?",
    faq6A: "Open the TikTok app/site, find your video, click 'Share' (arrow icon) and select 'Copy link'.",
    faq7Q: "Do I need to install applications or extensions?",
    faq7A: "No. We try to keep things easy for our users. All you need is your TikTok download links. That's it.",
    faq8Q: "Is there a limit to downloading TikTok videos at TikGrab?",
    faq8A: "No, you can download as many videos as you want without any restrictions.",
    faq9Q: "Does TikGrab support downloading multiple videos from a page/user/hashtag?",
    faq9A: "Currently, we only support downloading single videos one by one. You can paste the link for each video you want to save.",
    faq10Q: "Can I edit videos with TikGrab?",
    faq10A: "No, TikGrab is just a TikTok video downloader and doesn't support video editing. Use specialized video editing software for that.",
    faq11Q: "Does TikGrab provide TikTok MP3 download solution?",
    faq11A: "Yes, you can download any TikTok video as an MP3 audio file by choosing the 'Download MP3' option after the video is processed.",
    disclaimerNote: "TikGrab is not a product/tool of TikTok. We have no relationship with TikTok or ByteDance Ltd. Our goal is only to help TikTok users, so they can download our TikTok videos without any logo or complications. Thank you for choosing TikGrab!",
    aboutTitle: "About TikGrab",
    aboutDesc: "TikGrab is a leading provider of social media content preservation tools. Our mission is to empower creators and users to save their digital memories without the restrictions of platform watermarks.",
    contactTitle: "Contact Us",
    contactDesc: "Have questions or feedback? We'd love to hear from you.",
    privacyTitle: "Privacy Policy",
    termsTitle: "Terms of Service"
  },
  es: {
    heroTitle: "Descargar Video de TikTok",
    placeholder: "Simplemente inserte un enlace",
    paste: "Pegar",
    download: "Descargar",
    noWatermark: "Descargar Video (Sin Marca de Agua)",
    standard: "Descargar Video (Estándar)",
    withWatermark: "Descargar Video (Con Marca - Respaldo)",
    audioMp3: "Descargar Audio (MP3)",
    popularVideos: "Videos populares",
    howToSave: "¿Cómo guardar videos de TikTok?",
    featureUnlimited: "Descargas ilimitadas",
    featureUnlimitedDesc: "Guarde tantos videos como necesite, sin límites ni restricciones.",
    featureNoWatermark: "¡Sin Marca de Agua!",
    featureNoWatermarkDesc: "Descarga videos de TikTok sin marca de agua, elimina el logo de TikTok.",
    featureMp4Mp3: "Compatible con MP4 y MP3",
    featureMp4Mp3Desc: "Guarde videos en calidad HD, formato MP4 o conviértalos a audio MP3.",
    bottomHeading: "Descargar video de TikTok sin marca de agua",
    codecNote: "Nota: Los videos HD (HEVC) pueden verse solo como audio. Si esto sucede, use la opción 'Estándar' o 'Con Marca'.",
    loading: "Cargando videos populares...",
    backToHome: "Volver al Descargador",
    hdHevc: "Descargar Video (Sin Marca de Agua)",
    standardCompatible: "Descargar Video (Estándar)",
    downloading: "Descargando...",
    wait: "Espere por favor...",
    seoTextTitle: "¿Cómo descargar videos de TikTok sin marca de agua?",
    seoTextDesc: "TikGrab es la forma más rápida y sencilla de guardar videos de TikTok. Nuestra herramienta elimina la marca de agua y te permite descargar en calidad HD.",
    step1Title: "1. Copiar enlace",
    step1Desc: "Busca tu video en TikTok y copia su URL.",
    step2Title: "2. Pegar aquí",
    step2Desc: "Pega la URL en el cuadro de entrada de TikGrab.app.",
    step3Title: "3. Descargar",
    step3Desc: "Elige tu formato y guarda el video al instante.",
    faqTitle: "Preguntas frecuentes",
    faq1Q: "¿Es gratis?",
    faq1A: "¡Sí! TikGrab es completamente gratis para todos.",
    faq2Q: "¿Necesito una cuenta?",
    faq2A: "No es necesario registrarse para usar nuestro servicio.",
    faq3Q: "¿Funciona en iPhone?",
    faq3A: "Sí, funciona en todos los dispositivos modernos, incluidos iOS y Android.",
    faq4Q: "¿Es seguro?",
    faq4A: "Sí, no guardamos tus datos personales ni tus videos."
  },
  fr: {
    heroTitle: "Télécharger une vidéo TikTok",
    placeholder: "Insérez simplement un lien",
    paste: "Coller",
    download: "Télécharger",
    noWatermark: "Télécharger la vidéo (Sans filigrane)",
    standard: "Télécharger la vidéo (Standard)",
    withWatermark: "Télécharger Vidéo (Avec Filigrane - Secours)",
    audioMp3: "Télécharger l'audio (MP3)",
    popularVideos: "Vidéos populaires",
    howToSave: "Comment enregistrer une vidéo TikTok ?",
    featureUnlimited: "Téléchargements illimités",
    featureUnlimitedDesc: "Enregistrez autant de vidéos que vous le souhaitez, sans limites ni restrictions.",
    featureNoWatermark: "Sans filigrane TikTok !",
    featureNoWatermarkDesc: "Téléchargez des vidéos TikTok sans filigrane, cela supprime le logo TikTok.",
    featureMp4Mp3: "MP4 et MP3 supportés",
    featureMp4Mp3Desc: "Enregistrez des vidéos en qualité HD, format MP4 ou convertissez-les en audio MP3.",
    bottomHeading: "Télécharger une vidéo TikTok sans filigrane",
    codecNote: "Remarque : Les vidéos HD (HEVC) peuvent ne jouer que le son. Utilisez l'option 'Standard' ou 'Avec Filigrane'.",
    loading: "Chargement des vidéos populaires...",
    backToHome: "Retour au téléchargeur",
    hdHevc: "Télécharger Vidéo (Sans filigrane)",
    standardCompatible: "Télécharger Vidéo (Standard)",
    downloading: "Téléchargement...",
    wait: "Veuillez patienter..."
  },
  hi: {
    heroTitle: "टिकटॉक वीडियो डाउनलोड करें",
    placeholder: "बस एक लिंक डालें",
    paste: "पेस्ट करें",
    download: "डाउनलोड",
    noWatermark: "वीडियो डाउनलोड करें (बिना वॉटरमार्क)",
    standard: "वीडियो डाउनलोड करें (स्टैंडर्ड)",
    withWatermark: "वीडियो डाउनलोड करें (वॉटरमार्क के साथ - बैकअप)",
    audioMp3: "ऑडियो डाउनलोड करें (MP3)",
    popularVideos: "लोकप्रिय वीडियो",
    howToSave: "टिकटॉक वीडियो कैसे सेव करें?",
    featureUnlimited: "असीमित डाउनलोड",
    featureUnlimitedDesc: "जितने चाहें उतने वीडियो सेव करें, कोई सीमा या प्रतिबंध नहीं।",
    featureNoWatermark: "कोई टिकटॉक वॉटरमार्क नहीं!",
    featureNoWatermarkDesc: "बिना वॉटरमार्क के टिकटॉक वीडियो डाउनलोड करें, यह लोगो को हटा देता है।",
    featureMp4Mp3: "MP4 और MP3 समर्थित",
    featureMp4Mp3Desc: "HD क्वालिटी में वीडियो सेव करें, MP4 फॉर्मेट या MP3 में बदलें।",
    backToHome: "ডাউনলোডার-এ ফিরে যান",
    hdHevc: "वीडियो डाउनलोड करें (बिना वॉटरমार्क)",
    standardCompatible: "वीडियो डाउनलोड करें (स्टैंडर्ड)",
    downloading: "ডাউনলোড হচ্ছে...",
    wait: "অনুগ্রহ করে অপেক্ষা করুন..."
  },
  pt: {
    heroTitle: "Baixar Vídeo do TikTok",
    placeholder: "Basta inserir um link",
    paste: "Colar",
    download: "Baixar",
    noWatermark: "Baixar Vídeo (Sem Marca d'Água)",
    standard: "Baixar Vídeo (Padrão)",
    withWatermark: "Baixar Vídeo (Com Marca - Backup)",
    audioMp3: "Baixar Áudio (MP3)",
    popularVideos: "Vídeos Populares",
    howToSave: "Como salvar vídeo do TikTok?",
    featureUnlimited: "Downloads ilimitados",
    featureUnlimitedDesc: "Salve quantos vídeos precisar, sem limites.",
    featureNoWatermark: "Sem Marca d'Água do TikTok!",
    featureNoWatermarkDesc: "Baixe vídeos do TikTok sem marca d'água.",
    featureMp4Mp3: "MP4 e MP3 suportados",
    featureMp4Mp3Desc: "Salve vídeos em qualidade HD ou converta para MP3.",
    bottomHeading: "Baixar vídeo do TikTok sem marca d'água",
    codecNote: "Nota: Vídeos HD (HEVC) podem tocar apenas o áudio. Se isso ocorrer, use a opção 'Padrão' ou 'Com Marca'.",
    loading: "Carregando vídeos populares...",
    backToHome: "Volver",
    hdHevc: "Baixar Vídeo (Sem Marca d'Água)",
    standardCompatible: "Baixar Vídeo (Padrão)",
    downloading: "Baixando...",
    wait: "Por favor aguarde..."
  },
  de: {
    heroTitle: "TikTok Video herunterladen",
    placeholder: "Einfach Link einfügen",
    paste: "Einfügen",
    download: "Herunterladen",
    noWatermark: "Video herunterladen (Ohne Wasserzeichen)",
    standard: "Video herunterladen (Standard)",
    withWatermark: "Video herunterladen (Mit Wasserzeichen - Backup)",
    audioMp3: "Audio herunterladen (MP3)",
    popularVideos: "Beliebte Videos",
    howToSave: "Wie speichert man TikTok-Videos?",
    featureUnlimited: "Unbegrenzte Downloads",
    featureUnlimitedDesc: "Speichern Sie so viele Videos wie Sie benötigen.",
    featureNoWatermark: "Kein TikTok-Wasserzeichen!",
    featureNoWatermarkDesc: "Laden Sie TikTok-Videos ohne Wasserzeichen herunter.",
    featureMp4Mp3: "MP4 und MP3 unterstützt",
    featureMp4Mp3Desc: "Speichern Sie Videos in HD oder konvertieren Sie in MP3.",
    bottomHeading: "TikTok-Video ohne Wasserzeichen herunterladen",
    codecNote: "Hinweis: HD-Videos (HEVC) werden oft nur als Audio abgespielt. Nutzen Sie 'Standard' oder 'Mit Wasserzeichen'.",
    loading: "Beliebte Videos werden geladen...",
    backToHome: "Zurück",
    hdHevc: "Video herunterladen (Ohne Wasserzeichen)",
    standardCompatible: "Video herunterladen (Standard)",
    downloading: "Wird heruntergeladen...",
    wait: "Bitte warten..."
  },
  it: {
    heroTitle: "Scarica Video da TikTok",
    placeholder: "Basta inserire un link",
    paste: "Incolla",
    download: "Scarica",
    noWatermark: "Scarica Video (Senza Filigrana)",
    standard: "Scarica Video (Standard)",
    withWatermark: "Scarica Video (Con Filigrana - Backup)",
    audioMp3: "Scarica Audio (MP3)",
    popularVideos: "Video Popolari",
    howToSave: "Come salvare i video di TikTok?",
    featureUnlimited: "Download illimitati",
    featureUnlimitedDesc: "Salva tutti i video che vuoi, senza limiti.",
    featureNoWatermark: "Senza filigrana TikTok!",
    featureNoWatermarkDesc: "Scarica video TikTok senza la filigrana.",
    featureMp4Mp3: "Supporto MP4 e MP3",
    featureMp4Mp3Desc: "Salva video in HD o converti in MP3.",
    bottomHeading: "Scarica video TikTok senza filigrana",
    codecNote: "Nota: I video HD (HEVC) potrebbero essere riprodotti come solo audio. Usa l'opzione 'Standard' o 'Con Filigrana'.",
    loading: "Caricamento video popolari...",
    backToHome: "Indietro",
    hdHevc: "Scarica Video (Senza Filigrana)",
    standardCompatible: "Scarica Video (Standard)",
    downloading: "Download in corso...",
    wait: "Attendere prego..."
  },
  ar: {
    aboutVision: "رؤيتنا",
    aboutVisionDesc: "نحن نؤمن بإنترنت حر ومفتوح حيث يتحكم المستخدمون في المحتوى الذي ينشئونه. تم بناء تيك جراب على مبادئ السرعة والخصوصية والجودة.",
    contactIntro: "إذا كان لديك أي أسئلة أو تقارير أخطاء أو اقتراحات ميزات لـ TikGrab، فلا تتردد في الاتصال بنا عبر نموذج الاتصال.",
    contactName: "اسمك",
    contactEmail: "بريدك الإلكتروني",
    contactMessage: "رسالتك",
    contactSubmit: "إرسال الرسالة",
    downloader: "أداة التحميل",
    blog: "المدونة",
    tools: "الأدوات",
    legal: "قانوني",
    resources: "المصادر",
    blogAndGuides: "المدونة والخدمات",
    aboutUs: "من نحن",
    contactUs: "اتصل بنا",
    heroTitle: "تحميل فيديو تيك توك",
    placeholder: "فقط أدخل الرابط",
    paste: "لصق",
    download: "تحميل",
    noWatermark: "تحميل الفيديو (بدون علامة مائية)",
    standard: "تحميل الفيديو (عادي)",
    withWatermark: "تحميل الفيديو (مع العلامة - احتياطي)",
    audioMp3: "تحميل الصوت (MP3)",
    popularVideos: "فيديوهات شائعة",
    howToSave: "كيفية حفظ فيديو تيك توك؟",
    featureUnlimited: "تحميلات غير محدودة",
    featureUnlimitedDesc: "احفظ أي عدد تريده من الفيديوهات بدون حدود أو قيود.",
    featureNoWatermark: "بدون علامة تيك توك المائية!",
    featureNoWatermarkDesc: "قم بتحميل فيديوهات تيك توك بدون علامة مائية، حيث يتم إزالة شعار تيك توك.",
    featureMp4Mp3: "يدعم MP4 و MP3",
    featureMp4Mp3Desc: "احفظ الفيديوهات بجودة HD بتنسيق MP4 أو حولها إلى صوت MP3.",
    bottomHeading: "تحميل فيديو تيك توك بدون علامة مائية",
    codecNote: "ملاحظة: فيديوهات HD (HEVC) قد تعمل كصوت فقط في بعض المشغلات. إذا حدث هذا، يرجى استخدام خيار 'عادي' أو 'مع العلامة المائية'.",
    loading: "جاري تحميل الفيديوهات الشائعة...",
    backToHome: "العودة إلى أداة التحميل",
    hdHevc: "تحميل الفيديو (بدون علامة مائية)",
    standardCompatible: "تحميل الفيديو (عادي)",
    downloading: "جاري التحميل...",
    wait: "يرجى الانتظار...",
    seoTextTitle: "كيفية تحميل فيديوهات تيك توك بدون علامة مائية؟",
    seoTextDesc: "تيك جراب (TikGrab) هي الطريقة الأسرع والأسهل لحفظ فيديوهات تيك توك. أداتنا تزيل العلامة المائية وتسمح لك بالتحميل بجودة HD.",
    howToDownloadTitle: "كيفية تحميل فيديوهات تيك توك بدون علامة مائية؟",
    step1Title: "1. نسخ الرابط",
    step1Desc: "ابحث عن الفيديو الخاص بك على تيك توك وانسخ رابط URL الخاص به.",
    step2Title: "2. الصق هنا",
    step2Desc: "الصق رابط URL في صندوق الإدخال في TikGrab.app.",
    step3Title: "3. تحميل",
    step3Desc: "اختر التنسيق الخاص بك واحفظ الفيديو على الفور.",
    faqTitle: "الأسئلة الشائعة",
    faq1Q: "كيفية تحميل فيديو تيك توك على أندرويد أو آيفون؟",
    faq1A: "1. افتح الفيديو المطلوب في تطبيق تيك توك. 2. اضغط على زر المشاركة في أسفل اليمين، ثم اضغط على خيار نسخ الرابط. 3. عد إلى موقع TikGrab والصق الرابط المنسوخ في حقل العنوان أعلى هذه الصفحة، ثم اضغط على زر التحميل. 4. انتظر معالجة الفيديو، ثم اختر الجودة المطلوبة وقم بالتحميل.",
    faq2Q: "أين يتم حفظ فيديوهات تيك توك بعد التحميل؟",
    faq2A: "عند تحميل الملفات، يتم حفظها عادةً في المجلد الذي قمت بتعيينه كافتراضي في متصفحك. يمكنك تغيير هذا المجلد يدوياً من إعدادات المتصفح.",
    faq3Q: "كيفية تحميل فيديوهات تيك توك على جهاز الكمبيوتر الخاص بي؟",
    faq3A: "1. افتح موقع TikTok.com في متصفحك. 2. انسخ رابط الفيديو من شريط عنوان المتصفح أو بالضغط على 'مشاركة'. 3. الصق الرابط في TikGrab.app واضغط على تحميل.",
    faq4Q: "هل استخدام TikGrab مجاني؟",
    faq4A: "نعم، خدمتنا مجانية تماماً وغير محدودة. نحن لا نطلب أي أموال أو اشتراكات.",
    faq5Q: "هل يحتفظ TikGrab بنسخة من الفيديوهات المحملة؟",
    faq5A: "لا، TikGrab لا يخزن الفيديوهات. جميع الفيديوهات مستضافة على خوادم تيك توك. كما أننا لا نتتبع سجلات التحميل لمستخدمينا، مما يجعل استخدام TikGrab مجهول الهوية تماماً.",
    faq6Q: "كيف يمكنني الحصول على رابط فيديو تيك توك؟",
    faq6A: "افتح تطبيق/موقع تيك توك، ابحث عن الفيديو الخاص بك، اضغط على 'مشاركة' (أيقونة السهم) واختر 'نسخ الرابط'.",
    faq7Q: "هل أحتاج إلى تثبيت تطبيقات أو إضافات؟",
    faq7A: "لا. نحن نحاول تبسيط الأمور لمستخدمينا. كل ما تحتاجه هو روابط تحميل تيك توك فقط.",
    faq8Q: "هل هناك حد لتحميل فيديوهات تيك توك في TikGrab؟",
    faq8A: "لا، يمكنك تحميل أي عدد تريده من الفيديوهات دون أي قيود.",
    faq9Q: "هل يدعم TikGrab تحميل فيديوهات متعددة من صفحة/مستخدم/هاشتاق؟",
    faq9A: "حالياً، نحن ندعم فقط تحميل فيديوهات منفردة واحداً تلو الآخر. يمكنك لصق الرابط لكل فيديو تريد حفظه.",
    faq10Q: "هل يمكنني تعديل الفيديوهات باستخدام TikGrab؟",
    faq10A: "لا، TikGrab هو مجرد أداة لتحميل فيديوهات تيك توك ولا يدعم تحرير الفيديو. استخدم برامج تحرير الفيديو المتخصصة لذلك.",
    faq11Q: "هل يوفر TikGrab حلاً لتحميل تيك توك MP3؟",
    faq11A: "نعم، يمكنك تحميل أي فيديو تيك توك كملف صوتي MP3 باختيار خيار 'تحميل MP3' بعد معالجة الفيديو.",
    disclaimerNote: "TikGrab ليس منتجاً أو أداة تابعة لتيك توك. ليس لدينا أي علاقة مع TikTok أو ByteDance Ltd. هدفنا هو مساعدة مستخدمي تيك توك فقط. شكراً لاختياركم TikGrab!",
    aboutTitle: "حول تيك جراب",
    aboutDesc: "تيك جراب هو مزود رائد لأدوات حفظ محتوى وسائل التواصل الاجتماعي. مهمتنا هي تمكين المبدعين والمستخدمين من حفظ ذكرياتهم الرقمية.",
    contactTitle: "اتصل بنا",
    contactDesc: "هل لديك أسئلة أو ملاحظات؟ نود أن نسمع منك.",
    privacyTitle: "سياسة الخصوصية",
    termsTitle: "شروط الخدمة"
  },
  ru: {
    heroTitle: "Скачать видео из TikTok",
    placeholder: "Просто вставьте ссылку",
    paste: "Вставить",
    download: "Скачать",
    noWatermark: "Скачать видео (без водяного знака)",
    standard: "Скачать видео (стандарт)",
    withWatermark: "Скачать видео (с водяным знаком - копия)",
    audioMp3: "Скачать аудио (MP3)",
    popularVideos: "Популярные видео",
    howToSave: "Как сохранить видео из TikTok?",
    featureUnlimited: "Безлимитные загрузки",
    featureUnlimitedDesc: "Сохраняйте сколько угодно видео.",
    featureNoWatermark: "Без водяного знака TikTok!",
    featureNoWatermarkDesc: "Скачивайте видео TikTok без водяного знака.",
    featureMp4Mp3: "Поддержка MP4 и MP3",
    featureMp4Mp3Desc: "Сохраняйте видео в HD или конвертируйте в MP3.",
    bottomHeading: "Скачать видео TikTok без водяного знака",
    codecNote: "Примечание: HD видео (HEVC) могут играть без видео. Используйте 'стандарт' или 'с водяным знаком'.",
    loading: "Загрузка популярных видео...",
    backToHome: "Назад",
    hdHevc: "Скачать видео (без водяного знака)",
    standardCompatible: "Скачать видео (стандарт)",
    downloading: "Загрузка...",
    wait: "Пожалуйста, подождите..."
  },
  zh: {
    heroTitle: "下载 TikTok 视频",
    placeholder: "只需插入链接",
    paste: "粘贴",
    download: "下载",
    noWatermark: "下载视频 (无水印)",
    standard: "下载视频 (标准)",
    withWatermark: "下载视频 (有水印 - 备用)",
    audioMp3: "下载音频 (MP3)",
    popularVideos: "热门视频",
    howToSave: "如何保存 TikTok 视频？",
    featureUnlimited: "无限下载",
    featureUnlimitedDesc: "保存任意数量的视频。",
    featureNoWatermark: "无 TikTok 水印！",
    featureNoWatermarkDesc: "下载无水印的 TikTok 视频。",
    featureMp4Mp3: "支持 MP4 和 MP3",
    featureMp4Mp3Desc: "以 HD 质量保存视频或转换为 MP3 音频。",
    bottomHeading: "下载无水印 TikTok 视频",
    codecNote: "注意：HD 视频 (HEVC) 可能只有声音。请尝试“标准”或“有水印”选项。",
    loading: "正在加载热门视频...",
    backToHome: "返回",
    hdHevc: "下载视频 (无水印)",
    standardCompatible: "下载视频 (标准)",
    downloading: "正在下载...",
    wait: "请稍候..."
  },
  ja: {
    heroTitle: "TikTok 動画をダウンロード",
    placeholder: "リンクを貼り付けるだけ",
    paste: "貼り付け",
    download: "ダウンロード",
    noWatermark: "動画をダウンロード (透かしなし)",
    standard: "動画をダウンロード (標準)",
    withWatermark: "動画をダウンロード (透かしあり - 予備)",
    audioMp3: "オーディオをダウンロード (MP3)",
    popularVideos: "人気の動画",
    howToSave: "TikTok 動画の保存方法は？",
    featureUnlimited: "無制限ダウンロード",
    featureUnlimitedDesc: "制限なしで動画を保存できます。",
    featureNoWatermark: "TikTok の透かしなし！",
    featureNoWatermarkDesc: "透かしなしで TikTok 動画をダウンロードします。",
    featureMp4Mp3: "MP4 および MP3 対応",
    featureMp4Mp3Desc: "HD 画質の動画保存または MP3 への変換が可能。",
    bottomHeading: "透かしなし TikTok 動画ダウンロード",
    codecNote: "注意：HD 動画（HEVC）は音声のみの場合があります。「標準」または「透かしあり」をお試しください。",
    loading: "人気の動画を読み込み中...",
    backToHome: "戻る",
    hdHevc: "動画をダウンロード (透かしなし)",
    standardCompatible: "動画をダウンロード (標準)",
    downloading: "ダウンロード中...",
    wait: "お待ちください..."
  },
  ko: {
    heroTitle: "TikTok 동영상 다운로드",
    placeholder: "링크를 붙여넣으세요",
    paste: "붙여넣기",
    download: "다운로드",
    noWatermark: "동영상 다운로드 (워터마크 없음)",
    standard: "동영상 다운로드 (표준)",
    withWatermark: "동영상 다운로드 (워터마크 있음 - 백업)",
    audioMp3: "오디오 다운로드 (MP3)",
    popularVideos: "인기 동영상",
    howToSave: "TikTok 동영상을 저장하는 방법은 무엇인가요?",
    featureUnlimited: "무제한 다운로드",
    featureUnlimitedDesc: "필요한 만큼 동영상을 저장하세요.",
    featureNoWatermark: "TikTok 워터마크 없음!",
    featureNoWatermarkDesc: "워터마크 없이 TikTok 동영상을 다운로드합니다.",
    featureMp4Mp3: "MP4 및 MP3 지원",
    featureMp4Mp3Desc: "HD 화질로 저장하거나 MP3로 변환 가능.",
    bottomHeading: "워터마크 없는 TikTok 동영상 다운로드",
    codecNote: "참고: HD 동영상(HEVC)은 소리만 나올 수 있습니다. '표준'이나 '워터마크 있음'을 사용하세요.",
    loading: "인기 동영상 로드 중...",
    backToHome: "뒤로",
    hdHevc: "동영상 다운로드 (워터마크 없음)",
    standardCompatible: "동영상 다운로드 (표준)",
    downloading: "다운로드 중...",
    wait: "잠시만 기다려 주세요..."
  },
  tr: {
    heroTitle: "TikTok Videosu İndir",
    placeholder: "Sadece bir bağlantı yapıştırın",
    paste: "Yapıştır",
    download: "İndir",
    noWatermark: "Videoyu İndir (Filigransız)",
    standard: "Videoyu İndir (Standart)",
    withWatermark: "Videoyu İndir (Filigranlı - Yedek)",
    audioMp3: "Sesi İndir (MP3)",
    popularVideos: "Popüler Videolar",
    howToSave: "TikTok videosu nasıl kaydedilir?",
    featureUnlimited: "Sınırsız indirme",
    featureUnlimitedDesc: "Limitsiz video kaydedin.",
    featureNoWatermark: "TikTok Filigranı Yok!",
    featureNoWatermarkDesc: "TikTok videolarını filigransız indirin.",
    featureMp4Mp3: "MP4 ve MP3 destekli",
    featureMp4Mp3Desc: "HD kalitede kaydedin veya MP3'e dönüştürün.",
    bottomHeading: "Filigransız TikTok videosu indir",
    codecNote: "Not: HD videolar (HEVC) sadece sesli olabilir. 'Standart' veya 'Filigranlı' seçeneğini deneyin.",
    loading: "Popüler videolar yükleniyor...",
    backToHome: "Geri",
    hdHevc: "Videoyu İndir (Filigransız)",
    standardCompatible: "Videoyu İndir (Standart)",
    downloading: "İndiriliyor...",
    wait: "Lütfen bekleyin..."
  },
  vi: {
    heroTitle: "Tải Video TikTok",
    placeholder: "Chỉ cần dán liên kết",
    paste: "Dán",
    download: "Tải về",
    noWatermark: "Tải Video (Không Watermark)",
    standard: "Tải Video (Tiêu chuẩn)",
    withWatermark: "Tải Video (Có Watermark - Dự phòng)",
    audioMp3: "Tải Âm thanh (MP3)",
    popularVideos: "Video Phổ biến",
    howToSave: "Cách lưu video TikTok?",
    featureUnlimited: "Tải xuống không giới hạn",
    featureUnlimitedDesc: "Lưu video không giới hạn.",
    featureNoWatermark: "Không Watermark TikTok!",
    featureNoWatermarkDesc: "Tải video TikTok không có watermark.",
    featureMp4Mp3: "Hỗ trợ MP4 và MP3",
    featureMp4Mp3Desc: "Lưu video chất lượng HD hoặc chuyển sang MP3.",
    bottomHeading: "Tải video TikTok không watermark",
    codecNote: "Lưu ý: Video HD (HEVC) có thể chỉ có tiếng. Hãy thử bản 'Tiêu chuẩn' hoặc 'Có Watermark'.",
    loading: "Đang tải video phổ biến...",
    backToHome: "Quay lại",
    hdHevc: "Tải Video (Không Watermark)",
    standardCompatible: "Tải Video (Tiêu chuẩn)",
    downloading: "Đang tải...",
    wait: "Vui lòng đợi..."
  },
  id: {
    heroTitle: "Unduh Video TikTok",
    placeholder: "Cukup tempelkan tautan",
    paste: "Tempel",
    download: "Unduh",
    noWatermark: "Unduh Video (Tanpa Watermark)",
    standard: "Unduh Video (Standar)",
    withWatermark: "Unduh Video (Ada Watermark - Cadangan)",
    audioMp3: "Unduh Audio (MP3)",
    popularVideos: "Video Populer",
    howToSave: "Bagaimana cara menyimpan video TikTok?",
    featureUnlimited: "Unduhan tidak terbatas",
    featureUnlimitedDesc: "Simpan video sebanyak yang Anda butuhkan.",
    featureNoWatermark: "Tanpa Watermark TikTok!",
    featureNoWatermarkDesc: "Unduh video TikTok tanpa watermark.",
    featureMp4Mp3: "Mendukung MP4 dan MP3",
    featureMp4Mp3Desc: "Simpan video HD atau ubah ke MP3.",
    bottomHeading: "Unduh video TikTok tanpa watermark",
    codecNote: "Catatan: Video HD (HEVC) mungkin hanya ada suara. Gunakan opsi 'Standar' atau 'Ada Watermark'.",
    loading: "Memuat video populer...",
    backToHome: "Kembali",
    hdHevc: "Unduh Video (Tanpa Watermark)",
    standardCompatible: "Unduh Video (Standar)",
    downloading: "Mengunduh...",
    wait: "Mohon tunggu..."
  },
  th: {
    heroTitle: "ดาวน์โหลดวิดีโอ TikTok",
    placeholder: "เพียงแค่วางลิงก์",
    paste: "วาง",
    download: "ดาวน์โหลด",
    noWatermark: "ดาวน์โหลดวิดีโอ (ไม่มีลายน้ำ)",
    standard: "ดาวน์โหลดวิดีโอ (มาตรฐาน)",
    withWatermark: "ดาวน์โหลดวิดีโอ (มีลายน้ำ - สำรอง)",
    audioMp3: "ดาวน์โหลดเสียง (MP3)",
    popularVideos: "วิดีโอยอดนิยม",
    howToSave: "วิธีบันทึกวิดีโอ TikTok?",
    featureUnlimited: "ดาวน์โหลดไม่จำกัด",
    featureUnlimitedDesc: "บันทึกวิดีโอได้ไม่จำกัด.",
    featureNoWatermark: "ไม่มีลายน้ำ TikTok!",
    featureNoWatermarkDesc: "ดาวน์โหลดวิดีโอ TikTok แบบไม่มีลายน้ำ.",
    featureMp4Mp3: "รองรับ MP4 และ MP3",
    featureMp4Mp3Desc: "บันทึกวิดีโอ HD หรือแปรเป็น MP3.",
    bottomHeading: "ดาวน์โหลดวิดีโอ TikTok แบบไม่มีลายน้ำ",
    codecNote: "หมายเหตุ: วิดีโอ HD (HEVC) อาจมีแต่เสียง ให้ลองใช้ 'มาตรฐาน' หรือ 'มีลายน้ำ'.",
    loading: "กำลังโหลดวิดีโอยอดนิยม...",
    backToHome: "ย้อนกลับ",
    hdHevc: "ดาวน์โหลดวิดีโอ (ไม่มีลายน้ำ)",
    standardCompatible: "ดาวน์โหลดวิดีโอ (มาตรฐาน)",
    downloading: "กำลังดาวน์โหลด...",
    wait: "โปรดรอสักครู่..."
  },
  ur: {
    heroTitle: "ٹک ٹاک ویڈیو ڈاؤن لوڈ کریں",
    placeholder: "بس لنک پیسٹ کریں",
    paste: "پیسٹ کریں",
    download: "ڈاؤن لوڈ",
    noWatermark: "ویڈیو ڈاؤن لوڈ (بغیر واٹر مارک)",
    standard: "ویڈیو ڈاؤن لوڈ (اسٹینڈرڈ)",
    withWatermark: "ویڈیو ڈاؤن لوڈ (واٹر مارک کے ساتھ - بیک اپ)",
    audioMp3: "آڈیو ڈاؤن لوڈ (MP3)",
    popularVideos: "مشہور ویڈیوز",
    howToSave: "ٹک ٹاک ویڈیو کیسے محفوظ کریں؟",
    featureUnlimited: "لامحدود ڈاؤن لوڈز",
    featureUnlimitedDesc: "جتنی چاہیں ویڈیوز محفوظ کریں، کوئی حد نہیں۔",
    featureNoWatermark: "ٹک ٹاک واٹر مارک کے بغیر!",
    featureNoWatermarkDesc: "واٹر مارک کے بغیر ٹک ٹاک ویڈیوز ڈاؤن لوڈ کریں۔",
    featureMp4Mp3: "MP4 اور MP3 سپورٹڈ",
    featureMp4Mp3Desc: "ایچ ڈی کوالٹی میں ویڈیو محفوظ کریں یا MP3 میں تبدیل کریں۔",
    bottomHeading: "ٹک ٹاک ویڈیو ڈاؤن لوڈ واٹر مارک کے بغیر",
    codecNote: "نوٹ: ایچ ڈی ویڈیوز میں صرف آواز ہو سکتی ہے۔ 'اسٹینڈرڈ' یا 'واٹر مارک کے ساتھ' ٹرائی کریں۔",
    loading: "مشہور ویڈیوز لوڈ ہو رہی ہیں...",
    backToHome: "واپس",
    hdHevc: "ویڈیو ڈاؤن لوڈ (بغیر واٹر مارک)",
    standardCompatible: "ویڈیو ڈاؤن لوڈ (اسٹینڈرڈ)",
    downloading: "ڈاؤن لوڈ ہو رہا ہے...",
    wait: "براہ کرم انتظار کریں..."
  },
  bn: {
    heroTitle: "টিকটক ভিডিও ডাউনলোড করুন",
    placeholder: "শুধু লিঙ্ক পেস্ট করুন",
    paste: "পেস্ট করুন",
    download: "ডাউনলোড",
    noWatermark: "ভিডিও ডাউনলোড (জলছাপ ছাড়া)",
    standard: "ভিডিও ডাউনলোড (স্ট্যান্ডার্ড)",
    withWatermark: "ভিডিও ডাউনলোড (জলছাপসহ - ব্যাকআপ)",
    audioMp3: "অডিও ডাউনলোড (MP3)",
    popularVideos: "জনপ্রিয় ভিডিও",
    howToSave: "টিকটক ভিডিও কীভাবে সেভ করবেন?",
    featureUnlimited: "আনলিমিটেড ডাউনলোড",
    featureUnlimitedDesc: "আপনার যত খুশি ভিডিও সেভ করুন।",
    featureNoWatermark: "টিকটক জলছাপ ছাড়া!",
    featureNoWatermarkDesc: "জলছাপ ছাড়া টিকটক ভিডিও ডাউনলোড করুন।",
    featureMp4Mp3: "MP4 এবং MP3 সমর্থিত",
    featureMp4Mp3Desc: "HD কোয়ালিটিতে ভিডিও সেভ করুন বা MP3 তে রূপান্তর করুন।",
    bottomHeading: "টিকটক ভিডিও ডাউনলোড করুন জলছাপ ছাড়া",
    codecNote: "দ্রষ্টব্য: HD ভিডিও কেবল অডিও প্লে হতে পারে। সেক্ষেত্রে 'স্ট্যান্ডার্ড' বা 'জলছাপসহ' অপশন ব্যবহার করুন।",
    loading: "জনপ্রিয় ভিডিও লোড হচ্ছে...",
    backToHome: "ফিরে যান",
    hdHevc: "ভিডিও ডাউনলোড (জলছাপ ছাড়া)",
    standardCompatible: "ভিডিও ডাউনলোড (স্ট্যান্ডার্ড)",
    downloading: "ডাউনলোড হচ্ছে...",
    wait: "অনুগ্রহ করে অপেক্ষা করুন..."
  }
};
